export default async function (language) {
  const languages = {
    af: async () => await import("ckeditor5/translations/af.js"),
    ar: async () => await import("ckeditor5/translations/ar.js"),
    ast: async () => await import("ckeditor5/translations/ast.js"),
    az: async () => await import("ckeditor5/translations/az.js"),
    bg: async () => await import("ckeditor5/translations/bg.js"),
    ca: async () => await import("ckeditor5/translations/ca.js"),
    cs: async () => await import("ckeditor5/translations/cs.js"),
    da: async () => await import("ckeditor5/translations/da.js"),
    de: async () => await import("ckeditor5/translations/de.js"),
    "de-ch": async () => await import("ckeditor5/translations/de-ch.js"),
    el: async () => await import("ckeditor5/translations/el.js"),
    "en-au": async () => await import("ckeditor5/translations/en-au.js"),
    "en-gb": async () => await import("ckeditor5/translations/en-gb.js"),
    eo: async () => await import("ckeditor5/translations/eo.js"),
    es: async () => await import("ckeditor5/translations/es.js"),
    et: async () => await import("ckeditor5/translations/et.js"),
    eu: async () => await import("ckeditor5/translations/eu.js"),
    fa: async () => await import("ckeditor5/translations/fa.js"),
    fi: async () => await import("ckeditor5/translations/fi.js"),
    fr: async () => await import("ckeditor5/translations/fr.js"),
    gl: async () => await import("ckeditor5/translations/gl.js"),
    gu: async () => await import("ckeditor5/translations/gu.js"),
    he: async () => await import("ckeditor5/translations/he.js"),
    hi: async () => await import("ckeditor5/translations/hi.js"),
    hr: async () => await import("ckeditor5/translations/hr.js"),
    hu: async () => await import("ckeditor5/translations/hu.js"),
    id: async () => await import("ckeditor5/translations/id.js"),
    it: async () => await import("ckeditor5/translations/it.js"),
    ja: async () => await import("ckeditor5/translations/ja.js"),
    kk: async () => await import("ckeditor5/translations/kk.js"),
    km: async () => await import("ckeditor5/translations/km.js"),
    kn: async () => await import("ckeditor5/translations/kn.js"),
    ko: async () => await import("ckeditor5/translations/ko.js"),
    ku: async () => await import("ckeditor5/translations/ku.js"),
    lt: async () => await import("ckeditor5/translations/lt.js"),
    lv: async () => await import("ckeditor5/translations/lv.js"),
    nb: async () => await import("ckeditor5/translations/nb.js"),
    ne: async () => await import("ckeditor5/translations/ne.js"),
    nl: async () => await import("ckeditor5/translations/nl.js"),
    no: async () => await import("ckeditor5/translations/no.js"),
    oc: async () => await import("ckeditor5/translations/oc.js"),
    pl: async () => await import("ckeditor5/translations/pl.js"),
    pt: async () => await import("ckeditor5/translations/pt.js"),
    "pt-br": async () => await import("ckeditor5/translations/pt-br.js"),
    ro: async () => await import("ckeditor5/translations/ro.js"),
    ru: async () => await import("ckeditor5/translations/ru.js"),
    si: async () => await import("ckeditor5/translations/si.js"),
    sk: async () => await import("ckeditor5/translations/sk.js"),
    sl: async () => await import("ckeditor5/translations/sl.js"),
    sq: async () => await import("ckeditor5/translations/sq.js"),
    sr: async () => await import("ckeditor5/translations/sr.js"),
    "sr-latn": async () => await import("ckeditor5/translations/sr-latn.js"),
    sv: async () => await import("ckeditor5/translations/sv.js"),
    th: async () => await import("ckeditor5/translations/th.js"),
    tk: async () => await import("ckeditor5/translations/tk.js"),
    tr: async () => await import("ckeditor5/translations/tr.js"),
    tt: async () => await import("ckeditor5/translations/tt.js"),
    ug: async () => await import("ckeditor5/translations/ug.js"),
    uk: async () => await import("ckeditor5/translations/uk.js"),
    uz: async () => await import("ckeditor5/translations/uz.js"),
    vi: async () => await import("ckeditor5/translations/vi.js"),
    zh: async () => await import("ckeditor5/translations/zh.js"),
    "zh-cn": async () => await import("ckeditor5/translations/zh-cn.js"),
  };

  const translationModule = await languages[language]?.();

  if (translationModule?.default) {
    registerTranslation(translationModule.default);
  }
}

function registerTranslation(translations) {
  Object.entries(translations).forEach(([languageKey, translation]) => {
    const translationsRoot = window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
    const languageTranslations = translationsRoot[languageKey] || (translationsRoot[languageKey] = {});

    languageTranslations.dictionary = Object.assign(languageTranslations.dictionary || {}, translation.dictionary);
    languageTranslations.getPluralForm = translation.getPluralForm;
  });
}
